
import api from 'Plugins/api'
import { getDiffDays ,getStrDate} from 'Utils/dateUtil'

const TKSEARCHINFO = () => {
  return {
    depport: {},//出发机场 对象
    arrport: {},//到达进场
    depport0: {},//出发机场 对象
    arrport0: {},//到达进场
    minzj: '0',
    minzjName:'',
    clbzTitle: '', //差旅标准
    flights: [],//选中航班信息
    roundtrip: 0,//单程 往返
    queryStr: {
      arriveAirport: '',
      departAirport: '',
      departDate: '',
      empRank: '',
      tripType: '',
      arriveDate: '',
      showGpProduct:0,
    },
    queryStr0: {
      arriveAirport: '',
      departAirport: '',
      departDate: '',
      empRank: '',
      tripType: '',
      arriveDate: '',
      showGpProduct:0
    },
    ccsqd: {//出差单信息
      personList: [],//申请单出行人列表
    },
    departDate:{},
    arriveDate:{},
    violateList: [],
    adultNum: 0,//成人数量
    childNum: 0,//儿童
    babyNum: 0,//婴儿

    showTrain: false,//机票查询时，是否展示推荐高铁/动车二等座
    showMinPriceTips: false,//航班查询时，以弹窗形式提示 全天最低价
    train: {//推荐火车
      seatList: {}
    },
    priceList: [],//价格明细
    path: '/tk/tkEdit',
    backPath: '/tk/tkQuery',
    minDate: '',
    maxDate: '',
    cplx: '10901',
    showGpProduct:true,
    businesssingle:{} //出差申请单因私状态存的选中出差单的数据
		
  }
}

const tk = {
  namespaced: true,

  state: {//state就是Vuex中的公共的状态, 我是将state看作是所有组件的data, 用于保存所有组件的公共数据.
    tkSearchInfo: TKSEARCHINFO(),
    travelerList: [],
    pageCtrl: {},
    travelTips: {
      lastDate: '',
      depportCityid: '',
      arriveCityid: '',
    },
    flightCache:{},//航班列表缓存
    selectreason:'',//验价原因
    minFlightRemark:'',//列表原因
    tkcarpick:'',//接机数据
    tkcardrop:'',//送机数据
  },
  getters: {//getters属性理解为所有组件的computed属性, 也就是计算属性
    tkSearchInfo: (state, getters, rootSate, rootGetters) => {
      // console.log(getters, rootSate, rootGetters)
      return state.tkSearchInfo
    },
    travelerList: (state) => {
      return state.travelerList
    },
    pageCtrl: (state) => {
      return state.pageCtrl || []
    },
    travelTips: (state) => {
      return state.travelTips
    },
    flightCache: (state) => {
      return state.flightCache
    },
    setCookie(){
      let d = new Date()
    }
  },
  mutations: { //mutaions理解为store中的methods
    tkSearchInfo (state, payload) {
      Object.assign(state.tkSearchInfo , payload)
    },
    travelerList (state, payload) {
      state.tkSearchInfo.adultNum=0
      state.tkSearchInfo.childNum=0
      state.tkSearchInfo.babyNum=0
      if (payload&&payload.length>0) {
        payload.forEach(item => {
          if (!item.psgType || item.psgType == 1) {
            item.psgType=1
            state.tkSearchInfo.adultNum += 1
          } else if (item.psgType == 2) {
            state.tkSearchInfo.childNum+=1
          } else if (item.psgType == 3) {
            state.tkSearchInfo.babyNum+=1
          }
        })
      }
      state.travelerList = payload
    },
    setFlightCache (state, payload) { //航班列表缓存
      state.flightCache = payload
    },
    clearFlightCache (state, payload) { //清除航班列表缓存
      state.flightCache = {}
    },
    SET_VIOLATELIST (state, payload) {//违背原因回显
      state.tkSearchInfo.violate = payload
    },
    pageCtrl (state, payload) {//
      state.pageCtrl = payload
    },
    travelTips (state, payload) {//
      state.travelTips = payload
    },
    CLEAR_ALL (state, payload) {
      state.tkSearchInfo=TKSEARCHINFO()
      state.travelerList = []
      state.travelTips={
        lastDate: '',
        depportCityid:'',
        arriveCityid:'',
      }
    },
    businesssingle(state, payload){
      state.tkSearchInfo.businesssingle=''
      state.tkSearchInfo.businesssingle = payload
    },
    selectreason(state, payload){
      state.selectreason=payload
    },
    minFlightRemark(state, payload){
      state.minFlightRemark=payload
    },
    tkcarpick(state, payload){
      state.tkcarpick=payload
    },
    tkcardrop(state, payload){
      state.tkcardrop=payload
    },
  },
  actions: { //添加actions actions中可以包含异步操作
    /*
        *20019 机票查询时，是否展示推荐高铁/动车二等座
        *10914 航班查询时，以弹窗形式提示 全天最低价
        * */
    async getParams ({ dispatch,commit, state }) {
      try {
        let res = await api['common/queryParameter']({
          paramNos:'20019,10914'
        })
        let cache = res.data || {}
        let params = cache.parameterResponses || []
        params.forEach(item => {
          if (item.paramNo == 20019) {
            if (state.tkSearchInfo.backPath!='/tripRoute') {
              state.tkSearchInfo.showTrain = item.value1 == 1
            }
            if (state.tkSearchInfo.showTrain) {
              state.tkSearchInfo.train = {}
              if (getDiffDays(getStrDate(), state.tkSearchInfo.departDate.date) <= 29) {
                dispatch('getTrainList')
              }
            }
          } else if (item.paramNo == 10914) {
            state.tkSearchInfo.showMinPriceTips = item.value1 == 1
          }
        })
      } catch (err) {
        console.error(err)
      }
    },
    async getTrainList ({commit, state}) {
      try {
        let departCity=state.tkSearchInfo.depport.cityName
        let arriveCity = state.tkSearchInfo.arrport.cityName
        let depIndex = departCity.indexOf('(')//处理垃圾数据
        let arrIndex = arriveCity.indexOf('(')//处理垃圾数据
        if (depIndex>-1) { //处理垃圾数据
          departCity=departCity.substring(0,depIndex)
          arriveCity=arriveCity.substring(0,arrIndex)
        }
        if (arrIndex>-1) {//处理垃圾数据
          departCity=departCity.substring(0,depIndex)
          arriveCity=arriveCity.substring(0,arrIndex)
        }
        let resq = await api['trQuery/getCityDataByName']({
          cityName:departCity+','+arriveCity
        })
        let obj = {
          'allTrains': true, //是否包含距发车不到2hours的车次 ,
          'byTrainDate': state.tkSearchInfo.departDate.date, //乘车日期yyyy-MM-dd ,
          'fromStationCode': '', //出发站三字编码 ,
          'includePrice': true, // 是否包含票价 ，
          'minRank': state.tkSearchInfo.empRank||1, // 本次预订最低差标等级 ,
          'toStationCode': '' //目的站三字编
        }
        let info = resq.data || []
        if(info){
          info.forEach(function(el){
            if(el.cityName==arriveCity){
              obj.toStationCode=el.zddm
            }else if(el.cityName==departCity){
              obj.fromStationCode=el.zddm
            }
          })
        }
        api['trQuery/trSearch'](obj).then(res => {
          let cache = res.data || {}
          let list=cache.trainList||[]
          var trainTypeList= {'G':1, 'C':1, 'D':1}
          var arr=[]
          list.forEach(function(el){
            if(trainTypeList[el.trainType]){
              arr.push(el)
            }
          })
          arr.sort(function(a,b){
            return a.startTime<b.startTime
          })
          for (var el = 0; el < arr.length;el++){
            if(arr[el].seatList&&arr[el].seatList.length>0){
              for(var i=0;i<arr[el].seatList.length;i++){
                var set=arr[el].seatList[i]
                if (set.seatType == 'O' && set.seatCount > 0 && set.price && set.seatName && set.seatName != '无座') {
                  state.tkSearchInfo.train=arr[el]
                  state.tkSearchInfo.train.seatList=set
                  return
                }
              }
              if (state.tkSearchInfo.train.seatList) {
                return
              }
            }
          }
        }).catch(res => {
          console.log(res.tips)
        })
      } catch (err) {
        console.error(err)
      }
    }
  }
}
export default tk
